<div class="results-list">
    <div class="results-list__content">
        <div class="results-list__content__header">
            <ul>
                @if(declara){
                <li class="results-list__content__header--icon">
                    <span class="main-icon"></span>
                </li>
                }
                <li class="results-list__content__header--title">
                    @if(!declara){
                        <p>{{noDeclaraMessage}}</p>
                    } @else {
                        @if(nit) {
                            <p>{{declaraMessage}}</p>
                        } @else {
                            <p>{{declaraRutMessage}}</p>
                        }
                    }
                </li>
            </ul>
        </div>
        <div class="results-list__content__body">
            @if(!declara){
                <div class="results-list__content__body--no-declara">
                    <div class="results-list__content__body--no-declara--text-info">

                        <p>Revise su realidad económica, financiera y cumpla oportunamente con la presentación y pago de su declaración si corresponde. Tenga en cuenta que si responde <strong>“sí”</strong> a una o más de las siguientes preguntas, usted debe declarar renta:</p>
                    </div>
                    <div class="results-list__content__body--no-declara--list-items">
                        <ul>
                            @for (condition of conditionsList; track condition) {
                                <li><p>¿<span [innerHTML]="condition.html2 ? condition.html2 : condition.html"></span>?</p></li>
                            }
                        </ul>
                    </div>
                </div>
            } @else {
                <div class="results-list__content__body--declara declara" [class.no-toggler]="!enableToggler">
                    <div class="declara__header">
                        @if (name !== "") {
                        <div class="declara__name">
                            <span>{{name}}</span>
                        </div>
                        }
                        <div class="declara__description">
                            <p>Con base en el Sistema Integral de Información Tributaria y la información reportada por terceros, se evidencia que para el año gravable {{vigencia}}, <strong>usted cumple con una o más condiciones para ser declarante de renta</strong>, ya que:</p>
                        </div>
                    </div>
                    <div class="declara__details">
                        <div class="declara__details--checked">
                            <ul class="declara__details__conditions" [class.checked]="enableToggler && showWholeList" >
                                @for (condition of conditionsList; track condition) {
                                    @if(condition.checked) {
                                        <li class="declara__details__conditions--item condition-item">
                                            <div class="condition-item--wrapper">
                                                <div class="condition-item--icon">
                                                    <span class="icon-{{condition.icon}}"></span>
                                                </div>
                                                <div class="condition-item--description">
                                                    <div class="condition-item--description--title">
                                                        <span>{{condition.label}}</span>
                                                    </div>
                                                    <div class="condition-item--description--text">
                                                        <p><span class="condition-item--description--text-wrapper" [innerHTML]="condition.html"></span>.</p>
                                                    </div>
                                                </div>
                                                <div class="condition-item--check" >
                                                    <span class="icon-checked"></span>
                                                </div>
                                            </div>
                                        </li>
                                    }
                                }
                            </ul>
                        </div>
                        <div class="declara__details--unchecked">
                            @if(showWholeList){
                                <div class="declara__details--uchecked__list">
                                    <ul class="declara__details__conditions unchecked">
                                        @for (condition of conditionsList; track condition) {
                                            @if(!condition.checked) {
                                                <li class="declara__details__conditions--item condition-item">
                                                   <div class="condition-item--wrapper">
                                                        <div class="condition-item--icon">
                                                            <span class="icon-{{condition.icon}}"></span>
                                                        </div>
                                                        <div class="condition-item--description">
                                                            <div class="condition-item--description--title">
                                                                <span>{{condition.label}}</span>
                                                            </div>
                                                            <div class="condition-item--description--text">
                                                                <p><span [innerHTML]="condition.html"></span>.</p>
                                                            </div>
                                                        </div>
                                                   </div>
                                                </li>
                                            }
                                        }
                                    </ul>
                                </div>
                            }
                            @if(enableToggler) {
                                <div class="declara__details--unchecked__toggler" [class.reverse]="!showWholeList" [attr.tabindex]="0" (keypress.enter)="toggleUnchecked()" (click)="toggleUnchecked()" >
                                    <span>Lista completa de condiciones</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="results-list__content__body--notes">
                    @if(nit){
                        <div class="notes__banner">
                            <p>Tenga en cuenta que, de acuerdo con el <a target="_blank" [href]="links.calendarioTributario">calendario tributario</a>
                                y los dos últimos dígitos de su NIT {{numeroNit}}, la <strong>fecha límite</strong> para presentar su declaración de renta
                                es el <strong class="no-break">{{plazo}}</strong>. </p>
                        </div>
                    }@else {
                        <div class="notes__banner notes__banner--rut">
                            <p><a target="_blank" [href]="links.conozcaMasRut">Inscríbase en el RUT</a> y habilite su cuenta en el portal trámites y servicios DIAN. De esta forma, podrá consultar la información exógena (que terceros informan sobre usted) y tener acceso a nuestras herramientas para presentar su declaración. Conozca más sobre el RUT <a target="_blank" [href]="links.conozcaMasRut">aquí</a>.</p>
                            <p>Una vez inscrito consulte el calendario tributario para conocer la fecha límite para presentar su declaración de renta.</p>
                        </div>
                    }
                    <div class="notes__text">
                        <p><strong>Tenga en cuenta:</strong> Esta consulta está dirigida exclusivamente a personas que sean residentes fiscales en Colombia. Revise su realidad económica y financiera para presentar la declaración. </p>
                    </div>
                </div>
            }
        </div>
        <div class="results-list__content__footer">
            <div class="results-list__content__footer--notes">
                <div class="results-list__content__footer--notes__questions">
                    <a class="link" target="_blank" [href]="links.inquietudesRenta">
                        <span>Resuelva aquí sus inquietudes sobre renta {{ vigencia }}</span>
                    </a>
                </div>
                <div class="results-list__content__footer--notes__notes">
                    <p><strong>Nota:</strong> Si considera que esta información no refleja su situación económica y fiscal, guarde los documentos que respalden el cumplimiento de la normatividad. La administración tributaria puede hacer verificaciones.</p>
                    <p>En caso de que los datos entregados por terceros sean incorrectos, comuníquese con la entidad o persona que los reportó para corregirlos. La DIAN no puede añadir, modificar o rectificar información de terceros. </p>
                </div>
            </div>
            <div class="results-list__content__footer--return">
                <a class="link" [routerLink]="['/']" >
                    <span>Consultar otro número de documento</span>
                </a>
            </div>
        </div>
    </div>
</div>
